export default __webpack_public_path__ + "static/media/group-6234.4ff965f9.svg";